import Loading from '../../../Common/Loading';
import { UtilizationPerMonthPerYearAverage } from './UtilizationPerMonthPerYearAverage';
import { UtilizationPerMonthPerYearTotal } from './UtilizationPerMonthPerYearTotal';
import { UtilizationPerYearAverage } from './UtilizationPerYearAverage';
import { UtilizationPerYearTotal } from './UtilizationPerYearTotal';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

const ItermidiateCareUnit = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <UtilizationPerYearAverage />
                <UtilizationPerMonthPerYearAverage />
            </div>
            <div className="charts-side-by-side-dashboards">
                <UtilizationPerYearTotal />
                <UtilizationPerMonthPerYearTotal />
            </div>
        </>
    );
};

export default ItermidiateCareUnit;
